module.exports = __webpack_public_path__ + "static/media/bg-fill.c4c3b77e.jpg";